/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   HeaderMobileStr
 */

import { HamburgerCloseButton } from '@zcode-ui/controls'
import { Search, ZumperFullDark } from '@zcode-ui/icons'
import { Button } from '@zcode-ui/shadz-ui'
import React from 'react'
import type { PassedHeaderProps } from '../../../types'

interface HeaderMobileOtherPageProps {
  handleHamburgerClick: () => void
}

export const HeaderMobileOtherPage = ({
  handleHamburgerClick,
  onSearchButtonClick,
}: HeaderMobileOtherPageProps & Pick<PassedHeaderProps, 'onSearchButtonClick'>) => (
  <nav className="fixed top-0 right-0 left-0 h-[calc(1px*var(--header-height))] py-0 px-6 bg-gray-50 border-b border-solid border-gray-150 z-[1030]">
    <div className="flex justify-between items-center h-16 pt-3">
      <Button
        aria-label="Search"
        onClick={onSearchButtonClick}
        variant="ghost"
        className="h-5 min-w-5 p-0"
      >
        <Search fill="#0a0f1c" size={16} />
      </Button>
      <a aria-label="Zumper" href="/" className="block h-[34px] absolute right-1/2 translate-x-1/2">
        <ZumperFullDark size={34} />
      </a>
      <HamburgerCloseButton
        aria-label={'open side menu'}
        color="#0a0f1c"
        onClick={handleHamburgerClick}
      />
    </div>
  </nav>
)
